import { useState } from "react";
import axios from "axios";
import Loader from "./Loader";
import classes from "./PDFUploader.module.css";
import uploadIcon from "../assets/upload_icon.png";
import { useTranslation } from "react-i18next";
import InformationBox from "./InformationBox";
import ErrorBox from "./ErrorBox";

const UploadButton = ({
  title,
  invoiceId,
  invoiceType,
  imageType,
  allowedTypes,
  classList,
  setImage,
}) => {
  const { t } = useTranslation("general");
  const [status, setStatus] = useState({
    loading: false,
    success: false,
    failed: false,
  });

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB

  const validateFileSize = (file) => {
    if (file.size > MAX_FILE_SIZE) {
      setStatus({ loading: false, success: false, failed: true });
      return false;
    }
    return true;
  };

  const handleFileChange = async (e) => {
    const selectedFiles = e.target.files;
    if (selectedFiles.length === 0) return;

    const file = selectedFiles[0];
    if (!validateFileSize(file)) {
      return;
    }

    // Create FormData for API submission
    const formData = new FormData();
    Array.from(selectedFiles).forEach((selectedFile) => {
      formData.append("images", selectedFile);
    });
    formData.append("imageType", imageType);
    formData.append("invoiceId", invoiceId);
    formData.append("invoiceType", invoiceType);

    // Create preview URL for the image
    const previewUrl = URL.createObjectURL(file);

    // Send both the FormData and preview information to parent
    setImage({
      formData,
      preview: {
        url: previewUrl,
        name: file.name,
        type: file.type,
        size: file.size,
      },
    });
  };

  return (
    <div className="o-column">
      <div className={classList ? classList : ""}>
        <label
          htmlFor={`files-${invoiceType}`}
          className="o-row u-width_fit-content"
        >
          <span className={classes.customFileInput}>
            <img src={uploadIcon} alt={`Upload image`} />
            <span>{t(title)}</span>
          </span>
        </label>
        <input
          type="file"
          id={`files-${invoiceType}`}
          name="files"
          accept={allowedTypes}
          onChange={handleFileChange}
          className={classes.fileInput}
        />
      </div>
      {status.loading && <Loader />}
      {status.success && <InformationBox>{t("success")}</InformationBox>}
      {status.failed && (
        <div className="u-margin--top_200">
          <ErrorBox>{t("fileSizeTooLarge")}</ErrorBox>
        </div>
      )}
    </div>
  );
};

export default UploadButton;
